import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';

import { ITerminalNextID } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets the next terminal id
 * 
 * @returns {ITerminalNextID} the api response | error
 */
const GetNextTerminalID = async (): Promise<ITerminalNextID> => {
  try {
    apiRetry(awsApiInstance);

    const { data } = await awsApiInstance.get('/terminal/next');

    return data;
  } catch (error) {
    handleRouteError(error, 'Error getting next terminal id data');
    throw(error);
  }
}

export default GetNextTerminalID;